import { createSlice } from '@reduxjs/toolkit';
import appTypes from './types';
const initialState = {
    url: '',
};
const slice = createSlice({
    name: 'APP',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setUrl(state, { payload: urlNext }) {
            if (state.url !== urlNext) {
                state.parserResult = undefined;
            }
            state.url = urlNext;
        },
        setParserResult(state, { payload }) {
            state.parserResult = payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
